import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

import { CHART_COLORS } from "../constants";
import { brokerChartSeries } from "../helpers";

function BrokerChart({ brokerId, granularity }) {
  const { t, i18n } = useTranslation();
  const language = i18n.resolvedLanguage || "en";
  const series = useMemo(
    () => brokerChartSeries(brokerId, granularity),
    [brokerId, granularity],
  );

  const labels = series.map((bucket) => {
    if (granularity === "year") return bucket.key;
    if (granularity === "month") {
      const [year, month] = bucket.key.split("-");
      return new Intl.DateTimeFormat(language === "el" ? "el-GR" : "en-GB", {
        month: "short",
        year: "2-digit",
      }).format(new Date(Number(year), Number(month) - 1, 1));
    }
    return new Intl.DateTimeFormat(language === "el" ? "el-GR" : "en-GB", {
      day: "numeric",
      month: "short",
    }).format(new Date(bucket.key));
  });

  if (!series.length) return null;

  return (
    <Box sx={{ width: "100%", height: 300, mb: 2 }}>
      <BarChart
        xAxis={[{ scaleType: "band", data: labels }]}
        series={[
          {
            data: series.map((bucket) => bucket.properties),
            label: t("portfolioExplorer.chart.properties"),
            color: CHART_COLORS.property,
          },
          {
            data: series.map((bucket) => bucket.motors),
            label: t("portfolioExplorer.chart.motors"),
            color: CHART_COLORS.motor,
          },
        ]}
        height={280}
        margin={{ top: 56, bottom: 36, left: 44, right: 12 }}
        slotProps={{
          legend: {
            direction: "row",
            position: { vertical: "top", horizontal: "middle" },
            padding: 0,
          },
        }}
      />
    </Box>
  );
}

export default BrokerChart;
